import React, { useRef, useEffect, useState } from "react";
import HeroImage from "@/assets/HeroHeader.svg";
import MobileHeroHeader from "@/assets/MobileHeroHeader.svg";
import buttonGif from "@/assets/buttongif.gif";
import { Button } from "@/components/ui/button";
import { WaitlistPopup } from './Waitlistpopup';
import Waitlist from "@/assets/Waitlist.svg";
import buttonAnim from "../assets/Animation.json";
import Lottie from "lottie-react";
import Primary from "@/assets/Hover-Bg-Primary.png";
import Secondary from "@/assets/Hover-Bg-Secondary.png";
import lottibtn from "@/assets/PrimaryBg.json";
import { useLottie } from "lottie-react";
import { HoverBorderGradient } from "../components/ui/hover-border-gradient";
import { getOrCreateUserId } from "@/lib/session";
import { sendEvent } from "@/lib/googleSheet";
const EarlyWaitlist = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const sectionRef = useRef<HTMLDivElement>(null);
    const [isHovering, setIsHovering] = useState(false);
    const [isMobileHovering, setIsMobileHovering] = useState(false);
    const options = {
        animationData: lottibtn,
        loop: true
    };
    const { View } = useLottie(options);

    // MOBILE LOTTIE
    const mobileOptions = {
        animationData: lottibtn,
        loop: true,
        renderer: "svg" as const,
    };
    const { View: MobileView } = useLottie(mobileOptions);

    const handleWaitlistClick = () => {
        const userId = getOrCreateUserId();
        sendEvent(userId, "JOIN_WAIT_LIST_CLICK_3").catch(() => { });
        // setIsPopupOpen(true);
        window.location.href = "https://web.karatclub.in/";
    };

    const scrollToSection = () => {
        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    useEffect(() => {
        const handleHashChange = () => {
            if (window.location.hash === '#EarlyWaitlist') {
                scrollToSection();
            }
        };
        if (window.location.hash === '#EarlyWaitlist') {
            setTimeout(scrollToSection, 100);
        }
        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    useEffect(() => {
        const node = sectionRef.current;
        if (!node) return;
        const handleScroll = () => {
            const rect = node.getBoundingClientRect();
            const h = window.innerHeight;
            let p = Math.max(0, Math.min(1, (-rect.top + h * 0.2) / (h * 0.8)));
            node.style.setProperty("--progress", p.toString());
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div
                ref={sectionRef}
                id="EarlyWaitlist"
                className="relative min-h-[50vh] md:min-h-[70vh] flex items-center justify-center px-4 rounded-[24px] overflow-hidden"
                style={{
                    backgroundImage: `url(${Waitlist})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                {/* Gradient border overlay */}
                <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                        borderRadius: '24px',
                        padding: '0.78px',
                        background: 'radial-gradient(33.3% 25.84% at 61.34% 0%, #DBAD71 0%, #40404A 100%)',
                        WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                        WebkitMaskComposite: 'xor',
                        maskComposite: 'exclude',
                    }}
                ></div>
                <div className="relative z-10 max-w-4xl mx-auto text-center">
                    <h6 className="block md:hidden text-base font-bold text-[#FFFFFF] mb-6">
                        KaratClub is now Live
                    </h6>
                    <h1 className="hidden md:block text-4xl font-bold text-[#FFFFFF] mb-6">
                        KaratClub is now Live
                    </h1>
                    <h6 className="block md:hidden text-sm font-regular text-[#FFFFFF99] mb-6 text-center w-[95%] justify-self-center">
                        A private circle where your portfolio unlocks privileges, rewards, and experiences designed for modern investors.<br />
                        Membership is limited.
                    </h6>
                    <h1 className="hidden md:block text-lg font-regular text-[#FFFFFF99] mb-6 w-[60%] justify-self-center">
                        A private circle where your portfolio unlocks privileges, rewards, and experiences designed for modern investors.<br />
                        Membership is limited.
                    </h1>

                    {/* DESKTOP VERSION - Added onClick handler */}
                    <div className="hidden lg:block mb-10 w-full">
                        <div className="mx-auto" style={{ maxWidth: "40%" }}>
                            <HoverBorderGradient
                                className="relative overflow-hidden cursor-pointer group w-full rounded-lg"
                                onMouseEnter={() => setIsHovering(true)}
                                onMouseLeave={() => setIsHovering(false)}
                                onClick={handleWaitlistClick}
                                style={{
                                    border: "1px solid #313137",
                                    height: 50,
                                    background: "black",
                                }}
                            >
                                {/* LOTTIE ALWAYS MOUNTED */}
                                <div
                                    className={`absolute inset-0 transition-opacity duration-300 ${isHovering ? "opacity-0" : "opacity-100"
                                        }`}
                                >
                                    {View}
                                </div>

                                {/* SECONDARY IMAGE */}
                                <img
                                    src={Secondary}
                                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${isHovering ? "opacity-100" : "opacity-0"
                                        }`}
                                />

                                {/* "Join the Waitlist" Text */}
                                <div className="relative z-10 flex items-center justify-center h-full">
                                    <span
                                        className="text-white font-semibold tracking-wide"
                                        style={{
                                            fontSize: '20px',
                                            textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
                                        }}
                                    >
                                        Join the Club
                                    </span>
                                </div>
                            </HoverBorderGradient>
                        </div>
                    </div>


                    {/* MOBILE VERSION - Also add onClick handler */}
                    <div className="block lg:hidden w-full flex items-center justify-center mb-6"> {/* Added mb-6 for spacing */}
                        <div className="w-full max-w-[80%]"> {/* Using Tailwind classes instead of inline styles */}
                            <HoverBorderGradient
                                className="relative overflow-hidden cursor-pointer group w-full rounded-lg"
                                onMouseEnter={() => setIsMobileHovering(true)}
                                onMouseLeave={() => setIsMobileHovering(false)}
                                onClick={handleWaitlistClick}
                                style={{
                                    border: "1px solid #313137",
                                    height: 50,
                                    background: "black",
                                }}
                            >
                                {/* LOTTIE ALWAYS MOUNTED */}
                                <div
                                    className={`absolute inset-0 w-full h-full transition-opacity duration-300 ${isMobileHovering ? "opacity-0" : "opacity-100"
                                        }`}
                                >
                                    {MobileView}
                                </div>

                                {/* SECONDARY IMAGE */}
                                <img
                                    src={Secondary}
                                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${isMobileHovering ? "opacity-100" : "opacity-0"
                                        }`}
                                />

                                {/* "Join the Waitlist" Text */}
                                <div className="relative z-10 flex items-center justify-center h-full">
                                    <span
                                        className="text-white font-semibold tracking-wide"
                                        style={{
                                            fontSize: '20px',
                                            textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
                                        }}
                                    >
                                        Join the Club
                                    </span>
                                </div>
                            </HoverBorderGradient>
                        </div>
                    </div>
                </div>
            </div>

            <WaitlistPopup
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                onSubmit={(data) => console.log(data)}
            />
        </>
    );
};

export default EarlyWaitlist;